<template>
  <transition
    name="slide-up-down"
    @enter="onEnter"
    @leave="onLeave"
    @after-enter="onAfterEnter"
    @after-leave="onAfterLeave"
    :css="!ifDisabledAnimate"
  >
    <div
      v-if="showBlock"
      class="slide-up-down"
      :style="{ maxHeight: computedMaxHeight, transition: ifDisabledAnimate ? 'none' : '' }"
      :class="{'disable-animate': ifDisabledAnimate, 'default-active': isActive, 'slide-up-down__close': !isActive}"
    >
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ChatSlideUpDown',
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    ifDisabledAnimate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      computedMaxHeight: '0px',
      showBlock: this.isActive,
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.isActive) {
        this.computedMaxHeight = `max-content`;
      }
    });
  },
  methods: {
   onEnter(el) {
      if (this.ifDisabledAnimate) {
        this.computedMaxHeight = 'max-content';
      } else {
        this.computedMaxHeight = '0px';
        this.$nextTick(() => {
          this.computedMaxHeight = el.scrollHeight + 'px';
        });
      }
    },
    onAfterLeave(el) {
      this.computedMaxHeight = '0px';
    },
    onAfterEnter(el) {
      this.computedMaxHeight = 'auto';
      //el.style.overflow = '';
    },
    onLeave(el) {
      if (this.ifDisabledAnimate) {
        this.computedMaxHeight = '0px';
      } else {
        this.computedMaxHeight = el.scrollHeight + 'px';
        this.$nextTick(() => {
          this.computedMaxHeight = '0px';
        });
      }
    },
  },
  watch: {
    isActive(val) {
      if (val) {
        this.showBlock = true;
      } else if(this.computedMaxHeight === '0px' && this.showBlock) {
        this.showBlock = val;
      } 
    },
  },
};
</script>

<style scoped lang="scss">
.slide-up-down-enter-active,
.slide-up-down-leave-active {
  transition: max-height 0.4s ease;
  overflow: hidden;
}
.slide-up-down {
  overflow: hidden;
  transition: max-height 0.4s ease;
  &__close{
    max-height: 0 !important;
  }
  &.disable-animate{
    transition: none !important;
 }
}
.slide-up-down-enter-from,
.slide-up-down-leave-to {
  max-height: 0;
}
</style>
